export default {
  initText: '获取验证码',
  runText: '{%s}秒后重新获取',
  resetText: '重新获取验证码',
};
